import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Autocomplete, TextField, Checkbox, Box, Typography, FormControl } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useNavigate } from "react-router-dom";
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { authApi } from '../../api/api';
import { useDispatch, useSelector } from 'react-redux';


const Payroll = () => {

  const [locationOption, setLocationOptions] = useState([]);
  const [locationName, setLocationName] = useState(null);
  const [monthYear, setMonthYear] = useState('');
  const [monthYearOption, setMonthYearOption] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [rows, setRows] = useState([]);
  const [bonusApproval, setBonusApproval] = useState('All');

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  const handleCheckboxChange = (params, field) => {
    PayrollSum(params,field)  
  };

  useEffect(() => {
    // Fetch payroll data
    fetchLocation();  // Fetch locations  
    fetcYearMonth();  // Fetch month & year
    fetchUser();  // Fetch users
  },[]);

  useEffect(() => {
    if (monthYear && locationName){
      fetctPayroll(); // Fetch payroll data
    }
  }, [monthYear,locationName,selectedUser,bonusApproval]);


  const handleLocationChange = (event, newValue) => {
    setLocationName(newValue);
  };

  const handleMonthYearChange = (event, newValue) => {
    setMonthYear(newValue);
  };

  const handleUserChange = (event, newValue) => {
    setSelectedUser(newValue);
  };

  const handleProfessionalTypeChange = (event, newValue) => {
    setBonusApproval(newValue);
  };

  // Define fetchLocations separately to reuse it
  const PayrollSum = async (params,field) => {
    const input_token = 'MARK_PAYROLL_SUMMARY_AS_PAID'; // Replace with your actual token
    const apiUrl = 'paid_payroll'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID,
      user_initial: params.row.user_initial,
      month: params.row.month,
      year : params.row.year,
      paid_status: 1,
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row?.id === params?.row?.id ? { ...row, [field]: !row[field] } : row
          )
        );
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  // Define fetchLocations separately to reuse it
  const fetcYearMonth = async () => {
    const input_token = 'TIMESHEET_MONTH_YEAR'; // Replace with your actual token
    const apiUrl = 'get_month_year'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        setMonthYearOption(data.month_year);
        setMonthYear(data.month_year?.[0])
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  // Define fetchLocations separately to reuse it
  const fetchUser = async () => {
    const input_token = 'ALL_EMPLOYEES'; // Replace with your actual token
    const apiUrl = 'list_of_all_employee'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        const statesArray = data.clients.map(location => ({
          id: location.id,
          name: location.full_name, // Match `getOptionLabel`
          initial: location.initial
        }));

        statesArray.unshift({ id: 0, name: 'All', initial: 'All' });
        setUsers(statesArray)
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  // Define fetchLocations separately to reuse it
  const fetchLocation = async () => {
    const input_token = 'LOCATIONS'; // Replace with your actual token
    const apiUrl = 'list_of_locations'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        const statesArray = data.locations.map(location => ({
          id: location.id,
          locationname: location.location_name, // Match `getOptionLabel`
        }));
        statesArray.unshift({id: "All", locationname: 'All'} );
        setLocationOptions(statesArray);
        setLocationName(statesArray[0]);

      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  // Define fetchLocations separately to reuse it
  const fetctPayroll = async () => {
    const input_token = 'PAYROLL_SUMMARY'; // Replace with your actual token
    const apiUrl = 'payroll_summary'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID,
      location: locationName?.id, // Optional chaining is correctly used here
      month_year: monthYear,
      user: selectedUser?.initial, // Assuming you want to set it to null if initial exists
      bonus_approved: bonusApproval // Assuming you want to set it to null if bonusApproval is truthy
    };
    
    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      if (data && data.success) {
        setRows(data?.payroll_summary)
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  const columns = [
    {
      field: 'name', headerName: 'Name', flex: 1, renderCell: (params) => (
        <span style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>{params.value}</span>
      ),
    },
    {
      field: 'hoursCompleted', headerName: '% Hours Completed', flex: 1, renderCell: (params) => (
        <span style={{ color: params.value >= 80 ? 'green' : 'red' }}>{params.value}</span>
      )
    },
    {
      field: 'collectionRate', headerName: '% Collection Rate', flex: 1, renderCell: (params) => (
        <span style={{ color: params.value >= 70 ? 'green' : 'red' }}>{params.value}</span>
      )
    },
    { field: 'baseBonus', headerName: 'Base Bonus', flex: 1 },
    { field: 'extraBonus', headerName: 'Extra Bonus', flex: 1 },
    { field: 'totalBonus', headerName: 'Total Bonus', flex: 1 },
    {
      field: 'bonusApproved', headerName: 'Bonus Approved?', flex: 1, renderCell: (params) => (
        <span >{params.value ? 'Yes' : 'No'}</span>
      )
    },
    {
      field: 'paid', headerName: 'Paid', flex: 1, renderCell: (params) => (
        <Checkbox
          checked={params.value}
          disabled={!params.row.bonusApproved} // Disable if bonusApproved is false
          onChange={() => handleCheckboxChange(params, 'paid')}
        />
      )
    }
  ];

  return (
    <Box className="scorecard-container" padding={2}>
      <Box sx={{ width: '100%', padding: 2, backgroundColor: 'var(--theme-bg-light)', borderRadius: 2, }}>
        <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold' }}>
          Payroll Summary
        </Typography>
        <Grid container spacing={2} sx={{ marginBottom: 2 }} alignItems={"end"}>
          <Grid item size={{md: 2, xs: 12 }}>
            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Location</Typography>
            <FormControl fullWidth>
              <Autocomplete
                options={locationOption}
                getOptionLabel={(option) => option.locationname}
                value={locationName}
                onChange={handleLocationChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select location"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                    }}
                  />
                )}
                sx={{ width: '100%' }}
              />
            </FormControl>
          </Grid>
          <Grid item size={{md: 2, xs: 12 }}>
            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Month & Year</Typography>
            <FormControl fullWidth>
              <Autocomplete
                options={monthYearOption}
                value={monthYear}
                onChange={handleMonthYearChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select month & year"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                    }}
                  />
                )}
                sx={{ width: '100%' }}
              />
            </FormControl>
          </Grid>
          <Grid item size={{md: 2, xs: 12 }}>
            <Typography>User</Typography>
            <Autocomplete
              options={users}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => <TextField {...params} placeholder="Select User" />}
              value={selectedUser}
              onChange={handleUserChange}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
            />
          </Grid>
          <Grid item size={{md: 2, xs: 12 }}>
            <Typography>Bonus Approved</Typography>
            <Autocomplete
              options={['All', 'Yes', 'No']}
              renderInput={(params) => (
                <TextField
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                  {...params}
                  placeholder='Select Professional'
                  variant="outlined"
                />
              )}
              onChange={handleProfessionalTypeChange}
            />
          </Grid>
        </Grid>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={8}
          rowsPerPageOptions={[8]}
          className="data-grid"
          hideFooter
          disableSelectionOnClick
        />
      </Box>
    </Box>
  );
};

export default Payroll;
